import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import {AvatarTypeEnum} from "datnek-ds";

@Component({
  selector: 'nk-shared-enterprise-menu-mobile',
  templateUrl: './enterprise-menu-mobile.component.html',
  styleUrls: ['./enterprise-menu-mobile.component.scss'],
})
export class EnterpriseMenuMobileComponent implements OnInit {
  avatarEnum = AvatarTypeEnum;
  customOptions1: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      740: {
        items: 3,
      },
      940: {
        items: 4,
      },
    },
    nav: true,
  };

  constructor() {}

  ngOnInit(): void {}
}
